// import PropTypes from 'prop-types';
import { URL_LANDING_PAGE } from "../../utils/Constants";
import Body from "../../containers/Body";
import { checkIsBot, getServerSideData } from "../../utils/CommonUtils";
import redirection from "../../utils/redirection";

export default function PageView({ data, localeSettings }) {
  return (
    <div>
      <Body data={data} />
    </div>
  );
}

export async function getServerSideProps(context) {
  const currentDomainName = context.req.headers.host.split(":")[0];
  const isGoibibo = currentDomainName?.indexOf("goibibo") > -1 ? true : false;
  const isIntl = true;
  let dataMap = {
    isIntl,
    lob: "international-flights",
    currentDomainName,
    isGoibibo,
  };
  const blockRequestUrls = [
    "yolo.css.map",
    "%3C%25",  // encoded <%
    "%25%3E",  // encoded %>
    "<%=",     // decoded <%=
    "%>",      // decoded %>
  ];
  const { req } = context || {};

  let isBlocked = false;
  blockRequestUrls.forEach((url) => {
    if (req.url.includes(url)) {
      isBlocked = true;
    }
  });
  if (isBlocked) {
    return {
      redirect: {
        permanent: true,
        destination: "/",
      },
    };
  }

  dataMap = await getServerSideData(dataMap, context);
  dataMap.isGoibibo = isGoibibo;
  if (dataMap?.redirectObject) {
    return dataMap?.redirectObject;
  }
  dataMap.currentUrl = `https://${currentDomainName}${dataMap?.pageData?.route_url_path}`;
  if (dataMap?.error) {
    
    console.error("Error in dataMap ==>>>", dataMap?.error);
    return {
      redirect: {
        permanent: true,
        destination: isGoibibo
          ? `/flights`
          : `/international-flights?ccde=${dataMap?.ccde}`,
      },
    };
  }
  if (dataMap?.redirect) {
    return {
      redirect: {
        destination:
          currentDomainName && currentDomainName !== ""
            ? `https://${currentDomainName}/${dataMap.redirect}`
            : `${URL_LANDING_PAGE}/${dataMap.redirect}`,
        statusCode: 301,
      },
    };
  }
  return {
    props: {
      data: dataMap?.error ?? { ...dataMap },
    },
  };
}

// PageView.propTypes = {
//   data: PropTypes.object,
// };
